var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars),attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade-fast","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{attrs:{"isUserProspect":_vm.isUserProspect},on:{"postEstimate":_vm.postEstimate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }